export default __webpack_public_path__ + "static/media/AmazonPay.2ebeac7d.svg";